import React, { useState } from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { Widget } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { PatchedPostMetricResult } from 'schemas/PostMetricResultSchema'
import { getLabel } from 'utils/widgetTypeUtil'
import { SocialWebPopularLinksWidget as SocialWebPopularLinksWidgetType } from 'schemas/SocialWebPopularLinksWidgetSchema'
import PopularLinksWidgetDataGuards from '../share/guards/PopularLinksWidgetDataGuards'
import Table from '../share/Table'
import { PostMetricWithSoundbites } from '../types'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/InsightModal/useSelectedInsights'

const SocialWebPopularLinksWidget: Widget = ({ widgetId }) => {
  const widgetData = useDashboardWidgetData<PatchedPostMetricResult>(widgetId)
  const postMetrics = widgetData?.data?.[0].results?.[0].data.metrics as PostMetricWithSoundbites[]
  const [isModalOpen, setIsModalOpen] = useState(false)
  const widgetSetting = useDashboardWidgetSetting<SocialWebPopularLinksWidgetType>(widgetId)
  const {
    selectedInsight,
    detailSetting,
    handleRowClick,
    widgetSettingWithSelection
  } = useSelectedInsights(isModalOpen, widgetSetting, setIsModalOpen)

  return (
    <UnexpectedErrorBoundary>
      <PopularLinksWidgetDataGuards widgetId={widgetId}>
        <Table data={postMetrics} widgetId={widgetId} onRowClick={handleRowClick} />
      </PopularLinksWidgetDataGuards>
      <InsightModal
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        selectedInsight={selectedInsight}
        onClose={() => {
          setIsModalOpen(false)
        }}
        widgetSettingWithSelection={widgetSettingWithSelection}
        detailSetting={detailSetting}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebPopularLinksWidget
